import {
  SHOPIFY_API_VERSION,
  SHOPIFY_CUSTOM_DOMAIN,
  SHOPIFY_STOREFRONT_ACCESS_TOKEN
} from '@petplate/settings';
import { createStorefrontApiClient, type ClientResponse } from '@shopify/storefront-api-client';

type ResponseErrors = {
  message?: string;
  networkStatusCode?: number;
  graphQLErrors?: object[] | undefined;
};

export const errorToSentryBreadcrumb = (errors?: ResponseErrors) => ({
  message: errors?.message,
  data: {
    statusCode: errors?.networkStatusCode,
    graphqlErrors: errors?.graphQLErrors
  }
});

export const storefrontClient = createStorefrontApiClient({
  storeDomain: `https://${SHOPIFY_CUSTOM_DOMAIN}`,
  apiVersion: SHOPIFY_API_VERSION || '2025-01',
  publicAccessToken: SHOPIFY_STOREFRONT_ACCESS_TOKEN
});

/**
 * Checks if a Shopify Storefront API request failed
 * @param response - The response object from the Shopify Storefront API
 * @returns a boolean indicating if the request failed
 */
export const checkRequestFailed = (response: ClientResponse): boolean => !!response.errors;

/**
 * Extracts the numeric ID from a Shopify global ID (gid) string.
 * Shopify IDs are typically in the format "gid://shopify/<ObjectName>/1234567890"
 * @param {string} shopifyId - A full Shopify global ID string
 * @return {string} The numeric ID extracted from the Shopify ID, or an empty string if the passed ID is not valid
 */
export const extractShopifyObjectId = (shopifyId?: string | null) => {
  if (!shopifyId) return '';

  const match = shopifyId.match(/gid:\/\/shopify\/[^\/]+\/(\d+)/);
  if (match && match[1]) return match[1];
  return '';
};
